import React, { useMemo, useState, useEffect } from "react";
import { getData, columns, formatRowData, groupbyArrayN } from "./Data";
import { OrderStatusConstant } from "../../common/constants";
import { useTranslation } from "react-i18next";
import AppTable from "./AppTable";
import Pagination from "./Pagination";
import OverviewFilter from "./OverviewFilter";
import { useDispatch, useSelector } from "react-redux";
import { monthDigits } from "../../common/constants";
import {
  GetCurrentOrderList,
  GetLawyersByAssistant,
  GetLawyersByFirmID,
  lawFirmSelector,
} from "../../features/lawFirm/lawFirmSlice";
import { useForm } from "react-hook-form";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import { GetOrderLawyerInformations, orderLawyerInfoSelector } from "../../features/auth/orderLawyerInformationSlice";
import { getLawfirmForInternalUser } from "../../common/utils";
//import dropdownArrowImage from '/Images/dropdown-icon.475e8142.svg'
// import { ReactComponent as DropDownImage } from '../../../public/Images/dropdown-icon.475e8142.svg'

function OrderOverview({ overviewOrders, firmIDAndName, profileDetails, statusFilter, isCurrentFirmPromptFinancial }) {
  const [pageData, setPageData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: 0,
    totalOrders: 0,
    column: null,
    order: "ascending",
  });

  const { userLogin } = useSelector(authLoginSelector);
  const { DashboardLawfirm, lawyersByFirm, totalOrderCount, loadingOrderList } = useSelector(lawFirmSelector);
  console.log("🚀 ~ OrderOverview ~ totalOrderCount:", totalOrderCount)

  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const {
    register,
    control,
    reset,
    watch,
    setValue,
    getValues,
    trigger,
    formState: { errors },
  } = useForm();

  const [currentPage, setCurrentPage] = useState(0);
  const [filterValues, setFilterValues] = useState({});
  const [ordersPerPage, setOrdersPerPage] = useState(10);

  useEffect(() => {
    if (overviewOrders?.length > 0) {
      // Use totalOrderCount from API if available, otherwise fallback to array length
      // const total = totalOrderCount > 0 ? totalOrderCount : overviewOrders.length;
      const total = overviewOrders[0]?.totalRows || 0;
      console.log("🚀 ~ OrderOverview ~ total:", total)
      console.log("🚀 ~ OrderOverview ~ totalOrderCount:", overviewOrders[0]?.totalRows);

      setPageData({
        isLoading: loadingOrderList,
        rowData: formatRowData(overviewOrders, currentLanguage),
        totalPages: Math.ceil(total / ordersPerPage),
        totalOrders: total,
      });
    } else {
      setPageData({
        isLoading: loadingOrderList,
        rowData: [],
        totalPages: 0,
        totalOrders: 0,
      });
    }
  }, [overviewOrders, currentLanguage, totalOrderCount, ordersPerPage, loadingOrderList]);

  const dispatch = useDispatch();

  const onSort = (column, order) => {
    if (column !== null) {
      setPageData((prevState) => ({
        ...prevState,
        column,
        order,
      }));
      // Reset to first page when sorting changes
      setCurrentPage(0);
    }
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Trigger API call when page, sort, or filters change
  useEffect(() => {
    if (filterValues && Object.keys(filterValues).length > 0) {
      let { dateValue, deals, lawyerValue, status, search } = filterValues;
      if (typeof lawyerValue === "object") {
        lawyerValue = lawyerValue?.map(x => x.value).join(",")
      }

      if (firmIDAndName === null) return;
      dispatch(
        GetCurrentOrderList(
          getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser),
          1,
          dateValue || "",
          deals || "All",
          userLogin?.internalUser ? lawyerValue : userLogin?.isLawyer ? lawyerValue || userLogin?.userId.toString() : lawyerValue || "",
          status || "",
          search || "",
          true,
          pageData.column,
          pageData.order,
          userLogin?.internalUser ? "" : !userLogin?.isLawyer ? userLogin?.userId.toString() : "",
          currentPage + 1, // API expects 1-based page number
          ordersPerPage
        )
      );
    }
  }, [currentPage, pageData.column, pageData.order, filterValues]);

  const {
    lawyerInfo,
  } = useSelector(orderLawyerInfoSelector);

  const { t } = useTranslation();
  const [LawyerOptions, setLawyerOptions] = useState([]);

  // useEffect(() => {
  //         dispatch(GetLawyersByFirmID(getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser)));
  //         console.log("🚀 ~ OrderOverview ~ DashboardLawfirm:", DashboardLawfirm)
  // }, []);


  useEffect(() => {

    if (lawyersByFirm?.lawyers === undefined && firmIDAndName !== null)
      dispatch(GetLawyersByFirmID(getLawfirmForInternalUser(firmIDAndName, DashboardLawfirm, userLogin?.internalUser)));
    else {
      let lawyeroptions = [];
      lawyeroptions.push({ label: t('All'), value: "All" });
      lawyersByFirm?.lawyers?.map((item, i) => {
        lawyeroptions.push({ label: t(item.lawyer), value: item.userID });
      });
      setLawyerOptions(lawyeroptions);
    }
  }, [firmIDAndName, lawyersByFirm, DashboardLawfirm]);


  const DealTypeOptions = OrderStatusConstant("DealType").map(
    (item, i) => {
      return { label: t(item.label), value: item.value };
    }
  );

  const StatusOptions = OrderStatusConstant("Status").map((item, i) => {
    return { label: t(item.label), value: item.value, imageurl: item?.imageurl, ansvalue: item.ansvalue };
  });

  return (
    <div>

      {/* <button onClick={() => setCurrentPage(0)}>Reset</button> */}
      <OverviewFilter
        // loading={loading}
        DealTypeOptions={DealTypeOptions}
        LawyerOptions={LawyerOptions}
        StatusOptions={StatusOptions}
        onFilter={(values) => {
          setFilterValues((prev) => ({ ...prev, ...values }));
          setCurrentPage(0); // Reset to first page on filter change
        }}
        onPageReset={() => setCurrentPage(0)}
        firmIDAndName={firmIDAndName}
        tab={1}
        statusFilter={statusFilter}
        currentPage={currentPage}
        pageSize={ordersPerPage}
        sortColumn={pageData.column}
        sortOrder={pageData.order}
      />
      <div style={{ height: "auto" }}>
        {pageData.rowData && pageData.rowData.length > 0 && (
          <AppTable
            columns={columns}
            data={pageData.rowData}
            isLoading={pageData.isLoading}
            onSort={onSort}
            manualSorting
            isCurrentFirmPromptFinancial={isCurrentFirmPromptFinancial}
          />
        )}
      </div>
      <br />
      {!pageData.rowData || pageData?.rowData?.length === 0 &&
        <div className="text-center text-secondary-red font-semibold text-lg">
          {t('noResults')}
        </div>
      }
      <div>
        {(overviewOrders && overviewOrders?.length > 0 && pageData.totalOrders > 0) && (
          <Pagination
            totalRows={pageData.totalOrders}
            pageChangeHandler={handlePageChange}
            rowsPerPage={ordersPerPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </div>
  );
}

export default React.memo(OrderOverview);
